import workOrder from './workorder'
import jobPlan from './jobplan'
import jobTask from './jobtask'
import jobPlanSpec from './jobplanspec'
import jobPlanScene from "./jobplanscene";
const WorkOrderServer = {
  workOrder : workOrder,
  jobPlan : jobPlan,
  jobTask : jobTask,
  jobPlanSpec : jobPlanSpec,
  jobPlanScene : jobPlanScene,
};

export default WorkOrderServer;
